import React from 'react';
import {
  FlexColumn,
  FlexRow,
  HashLength,
  TruncateBox,
} from '@make-software/cspr-ui';
import { Tooltip, BodyText } from '@block-explorer/ui';
import { DeployContractPackageResult } from '@block-explorer/entities';
import { HashLink } from '../hash-link/hash-link';
import { buildRouterPath } from '../../router/utils';
import { CONTRACT_PACKAGE_PATH } from '../../router/paths';
import ContractIcon from '../contract-icon/contract-icon';
import { AvatarProps } from '../avatar/avatar';
import { HashFontSize } from '../table-data-account-info/table-data-account-info';

interface ContractIdentifierWithNameProps {
  hash: string;
  contractPackage: DeployContractPackageResult;
  hashLength?: HashLength;
  avatarSize?: AvatarProps['size'];
  hashFontSize?: HashFontSize;
  loading?: boolean;
}

export const ContractIdentifierWithName = ({
  hash,
  contractPackage,
  avatarSize = 'default',
  hashLength = HashLength.TINY,
  loading,
}: ContractIdentifierWithNameProps) => {
  const { latest_version_contract_type_id, icon_url, name, contract_name } =
    contractPackage;

  const contractName = name || contract_name;
  const path = buildRouterPath(CONTRACT_PACKAGE_PATH, { id: hash }, undefined);

  return (
    <FlexRow align={'center'} itemsSpacing={12}>
      <ContractIcon
        src={icon_url}
        size={avatarSize}
        contractTypeId={latest_version_contract_type_id}
        loading={loading}
      />
      <Tooltip title={hash} monotype>
        <FlexColumn>
          {contractName ? (
            <>
              <BodyText size={3} monotype>
                <HashLink hash={hash} href={path} hashLength={hashLength} />
              </BodyText>
              <TruncateBox size={2}>
                <BodyText size={3} variation="darkGray" noWrap>
                  {contractName}
                </BodyText>
              </TruncateBox>
            </>
          ) : (
            <BodyText size={3} monotype>
              <HashLink href={path} hash={hash} hashLength={hashLength} />
            </BodyText>
          )}
        </FlexColumn>
      </Tooltip>
    </FlexRow>
  );
};
